// A date-only string ("2026-10-01") names a calendar day, not a moment.
// new Date("2026-10-01") reads it as midnight UTC, which is still the day
// before anywhere in the Americas, so due dates, birthdays and term starts
// showed a day early. This reads it as that day on the viewer's clock; a
// full timestamp passes through as the moment it is.
export const toCalendarDate = (value) => {
  if (!value) return null;
  const m = typeof value === 'string' && value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(value);
};
